/**
 * @generated SignedSource<<1b9bd65a746490b0c8e3781dcdaf6946>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AllSkillsFilterInput = {
  isActive?: boolean | null | undefined;
  skillCode?: string | null | undefined;
  skillName?: string | null | undefined;
  skillType?: string | null | undefined;
  standardGradeIds?: ReadonlyArray<string> | null | undefined;
  targetGroupIds?: ReadonlyArray<string> | null | undefined;
  targetIds?: ReadonlyArray<string> | null | undefined;
};
export type ReportHubDiagnosticAssessmentTotalQuery$variables = {
  filter: AllSkillsFilterInput;
};
export type ReportHubDiagnosticAssessmentTotalQuery$data = {
  readonly allSkills: {
    readonly totalCount: number;
  } | null | undefined;
};
export type ReportHubDiagnosticAssessmentTotalQuery = {
  response: ReportHubDiagnosticAssessmentTotalQuery$data;
  variables: ReportHubDiagnosticAssessmentTotalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
      }
    ],
    "concreteType": "SkillNodeConnection",
    "kind": "LinkedField",
    "name": "allSkills",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ReportHubDiagnosticAssessmentTotalQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ReportHubDiagnosticAssessmentTotalQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3287103ff286fd669efef26b06b8a36c",
    "id": null,
    "metadata": {},
    "name": "ReportHubDiagnosticAssessmentTotalQuery",
    "operationKind": "query",
    "text": "query ReportHubDiagnosticAssessmentTotalQuery(\n  $filter: AllSkillsFilterInput!\n) {\n  allSkills(filter: $filter) {\n    totalCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "9412b1be246a4f63b759db4458557892";

export default node;
